// src/ConferenceTable.js
import React from 'react';
import './Conferences.css';
import Footer from '../Components/Footer';

import MegaNavbar from '../Components/MegaNavbar';
  
  const Conferences = () => {
    
    const conferences = [
      { id: 1, name: "Emerging Problem of the Developing Countries: Indigenous Responses & Way Forward", level: "International", date: "2016" },
      { id: 2, name: "International Conference on the Question Of Pakhtun Identity in the Pak-Afghan Region: Challenges & Prospects", level: "International", date: "2016" },
      { id: 3, name: "24th IAHA International Conference on Asian History, Culture and Environment: Vernacular and Oriental Paradigms", level: "International", date: "2016" },
      { id: 4, name: "Federalism in Pakistan: Challenges & Prospects", level: "National", date: "2017" },
      { id: 5, name: "First National Conference on Emerging Trends in Mathematics, Computing and Statistics NCETMCS 2017", level: "National", date: "2017" },
      { id: 6, name: "4th International Multidiciplinacy Research Conference on Global Prosperity through Research & Development (IMRC-2018)", level: "International", date: "2018" },
      { id: 7, name: "International Conference on China-Pakistan Economic Corridor (ICCPEC)", level: "International", date: "2018" },
      { id: 8, name: "National Conference on Mainstreaming Tribal Areas in Khyber Pakhtunkhwa: Prospects and Challenges 2018", level: "International", date: "2018" },
      { id: 9, name: "Zoom webinar: International Conference on Contemporary Issues & Challenges of Whistle Blowing in HEI", level: "International (Virtual)", date: "2022" },
      { id: 10, name: "International Seerah conference 2022", level: "International", date: "2022" },
      { id: 11, name: "Second International Conference on Psychology Women's Mental Health Care", level: "International", date: "2022" },
      { id: 12, name: "7th Multidisciplinary Research Conference", level: "National", date: "2022" },
    
    ];
    
    return (
      <>
      <MegaNavbar/>
      
      <div className="table-container container">
      <h2>Conferences</h2>
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Conferences</th>
              <th>Level</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {conferences.map((conference, index) => (
              <tr key={conference.id}>
                <td className='ttext'>{index + 1}</td>
                <td className='ttext' >{conference.name}</td>
                <td className='ttext'>{conference.level}</td>
                <td className='ttext'>{conference.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Footer/>
      </>
    );
  };
  
  

export default Conferences;
